<script>
export default {};
</script>

<template>
    <h1 class="Headline"><slot></slot></h1>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Headline
    color $cPrimary
    font-size 50px
    margin 40px 0
    font-weight 700
    position relative
    &.small
        font-size 28px
        margin 15px 0
    &.xsmall
        font-size 24px
</style>


